import {selectedComparables} from 'api/reports/comparable/SelectedComparables';
import {withSelectedImageUri} from 'api/reports/comparable/WithSelectedImageUri';
import {maskRequest} from 'lib/PropertyUtils';
import {disclosedSalePrice} from 'api/reports/comparable/DisclosedSalePrice';

export const makeComparableSection = (sectionName, section, featureFlags, userSettings, propertyNotes, enableUndisclosedPrice) => {
  const selectedSection = selectedComparables(section).map(withSelectedImageUri);
  const maskedSection = selectedSection.map(s => maskRequest(s, s.displayFields));
  maskedSection
    .forEach(s => {
      const propertyNote = propertyNotes[s.propertyId];
      if (['selected', sectionName].reduce((acc, p) => (acc || {})[p], propertyNote)) {
        s.propertyNotes = propertyNote.note;
        s.notesTitle = userSettings.notesTitle;
      }
      if (sectionName === 'sales') {
        s.salePrice = disclosedSalePrice(enableUndisclosedPrice, s);
      }
    });
  return maskedSection;
};